import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
  SimpleChanges,
} from "@angular/core";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FormControl } from "@angular/forms";
import { ElementRef } from "@angular/core";

@Component({
  selector: "app-search-input",
  templateUrl: "./search-input.component.html",
  styleUrls: ["./search-input.component.css"],
})
export class SearchInputComponent {
  @Input("dataInput") dataInput: string | undefined;
  @Input("required") required: boolean = false;
  @Input("lock") lock: boolean = false;
  @Input("isTable") isTable: boolean = false;
  @Input("isButtonActive") isButtonActive: boolean = false;
  @Input("placeHolder") placeHolder: string = "Search...";
  @Input("isAuto") isAuto: boolean = false;
  @Input("isDate") isDate: boolean = false;

  @Output() dataOutput = new EventEmitter<string>();
  @Output() clickSearch = new EventEmitter<Event>();

  searchControl = new FormControl("");
  isInsideInput: boolean = false;
  faSearch = faSearch;

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const clickedInside =
      this.elementRef.nativeElement.contains(target);

    if (clickedInside) {
      this.isInsideInput = true;
    } else {

      if (
        this.isAuto &&
        this.searchControl.value &&
        this.isInsideInput
      ) {
        this.isInsideInput = false;
        this.clickSearch.emit(event);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["dataInput"]) {
      this.searchControl.setValue(this.dataInput ?? "", {
        emitEvent: false,
      });
    }

    if (changes["lock"]) {
      if (this.lock) {
        this.searchControl.disable({ emitEvent: false });
      } else {
        this.searchControl.enable({ emitEvent: false });
      }
    }
  }

  constructor(private elementRef: ElementRef) {
  }

  updateFormControl(event: any): void {
    const value = (event.target as HTMLInputElement).value;
    this.searchControl.setValue(value);
    this.dataOutput.emit(value);
  }

  search(event: any): void {
    if (this.isButtonActive) {
      this.clickSearch.emit(event);
    }
  }
}
